export default __webpack_public_path__ + "static/media/TopGator2.ed4d6179.jpg";